var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"biFont icon-hidden left",class:{hiddenColor:_vm.axisShow},style:({
     width:_vm.axisMargin-1+'px',
     height:_vm.axisMargin-1+'px'}),attrs:{"title":_vm.axisShow?'隐藏标尺':'显示标尺'},on:{"click":_vm.toggleAxisShow}}),_vm._v(" "),_c('canvas',{ref:"ruler",class:{hidden:!_vm.axisShow},attrs:{"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca858d42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapEditor/canvas/Ruler/Ruler.vue
// module id = null
// module chunks = 